export default {
  main_manager: [
    {
      action: ["show"],
      subject: ["NavProfile"]
    },
    {
      action: ["show"],
      subject: ["CurrentOnline"]
    }
  ],
  admin: [
    {
      action: ["show"],
      subject: ["NavProfile"]
    },
    {
      action: ["show"],
      subject: ["CurrentOnline"]
    }
  ],
  manager: [
    {
      action: ["show"],
      subject: ["NavProfile"]
    },
    {
      action: ["show"],
      subject: ["CurrentOnline"]
    }
  ]
};
